import React, { Component } from 'react';
import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';

class TextArea extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    var input = (
      <div className="form-control-wrapper">
        <FormControl 
          componentClass="textarea"
          id={this.props.inputId}
          name={this.props.inputId}
          value={this.props.value || ''}
          onChange={this.props.handleOnChange}
        />
      </div>
    );
    var readOnly = null;

    if(this.props.readOnly) {
      input = null;
      readOnly = (
        <p className="formOnlyReadData">{this.props.value}</p>
      );
    }

    return (
      <div id={this.props.id} className={this.props.className + (this.props.error ? " invalidInput" :"")}>
        <FormGroup>
          <ControlLabel>
            {this.props.label}
            {(this.props.required && !this.props.readOnly) && (<span className="required">(*)</span>)}
          </ControlLabel>
          {readOnly}    
          {input}
        </FormGroup>
        {this.props.error && (<span className={"required-message"}>{this.props.error}</span>)}
      </div>
    );
  }
}

TextArea.propTypes = {};

export default TextArea;



// WEBPACK FOOTER //
// ./source/client/components/tasks_manager/form_components/textArea.jsx